import React, { Component } from 'react';
import { connect } from 'shalala';
import { Spinner, Col, Row, Button } from 'react-bootstrap';

import { useStore } from '../../store';
import EmisorStatus from './enum/EmisorStatus';
import EmisorTaxInfo from './info/EmisorTaxInfo';
import Loading from '../../facturotopia/loading/Loading';
import PageHeader from '../../support/page-header/PageHeader';
import EmisorEditActions from './upsert/components/EmisorEditActions';

class EmisoresInfo extends Component {
  state = {};

  constructor(props) {
    super(props);

    const { data = {} } = props.location.state || {};
    const { id } = this.props.match.params;

    this.state = {
      data: !!data.id ? { ...data } : { id },
    };

    const { data: emisor } = props.info;

    if (!data.rfc) {
      this.state = {
        data: {
          ...emisor,
        },
      };
    }
  }

  componentDidMount() {
    const { data } = this.state;

    if (!data.rfc) {
      this.props.history.replace('/app/emisores');
    } else if (!this.props.info.data || !this.props.info.data.rfc) {
      this.props.infoActions.setPartialState({ data });
    }
  }

  handleOnInviteClick = () => {
    const { data } = this.state;

    this.props.history.push({
      pathname: `/app/emisores/${data.id}/editar`,
      state: {
        data: { ...data },
      },
    });
  };

  render() {
    const { data = {}, busy } = this.props.info;

    if (!!busy) {
      return <Loading className="text-info" />;
    }

    const status = EmisorStatus.search(data.status) || EmisorStatus.undefined();

    return (
      <>
        <PageHeader
          text="Emisores"
          to="/app/emisores"
        />

        <h5>
          <Row>
            <Col>
              {!!busy && (
                <Spinner
                  animation="border"
                  role="status"
                  size="sm"
                  className="mr-3"
                >
                  <span className="sr-only">Buscando emisor...</span>
                </Spinner>
              )}
              {data.rfc || '...'}
            </Col>
            <Col className="text-right ml-auto">{!status.isInvited() && <EmisorEditActions data={data} />}</Col>
          </Row>
        </h5>

        {!!data.rfc && (
          <div>
            {status.isInvited() && (
              <div className="py-2">
                <p>Para comenzar a emitir facturas a tu socio de negocios, es necesario que completes tu información</p>

                <Button
                  type="button"
                  variant="secondary"
                  onClick={this.handleOnInviteClick}
                >
                  Completar
                </Button>
              </div>
            )}
            <div className="d-block mt-3 mb-2">
              <strong className="text-muted">Detalles</strong>
            </div>

            <EmisorTaxInfo data={data} />
          </div>
        )}
      </>
    );
  }
}

const mapState = (store) => {
  return { info: store.app.emisores.info };
};

const mapActions = (actions) => {
  return { infoActions: actions.app.emisores.info };
};

export default connect(useStore, mapState, mapActions)(EmisoresInfo);
